<section class="interaction" id="interaction">
    <div class="interaction__title">
        <h1>Drug Interaction <span class="ref">(03)</span></h1>
    </div>

    <div class="interaction__content">
        <div data-aos="zoom-out-right" class="interaction__content__warning">
            <div class="interaction__content__warning__img">
                <img src="../../../assets/Drug Intercation2.png" alt="" srcset="">
            </div>
            <div class="interaction__content__warning__content">
                <h4>
                    These Active Drug ingredients can not be taken with this product as it reacts resulting in side effects.
                </h4>
            </div>
        </div>

        <div class="interaction__content__list">
            <div data-aos="fade-up" data-aos-duration="500" *ngFor="let interaction of interactions" class="interaction__content__list__item" >
                <span>
                    {{interaction || 'No interaction with most drugs'}}
                </span>

            </div>
            <!-- <div data-aos="fade-up" data-aos-duration="800" class="interaction__content__list__item">
                <span>
                    Drug Ingredient
                </span>

            </div>
            <div data-aos="fade-up" data-aos-duration="500" class="interaction__content__list__item">
                <span>
                    Drug Ingredient
                </span>

            </div>
            <div data-aos="fade-up" data-aos-duration="800" class="interaction__content__list__item">
                <span>
                    Drug Ingredient
                </span>

            </div> -->

        </div>
    </div>
</section>
